export default {
  all: 'all',
  new: 'new',
  depositPaid: 'deposit_paid',
  upcoming: 'upcoming',
  inProgress: 'inprogress',
  completed: 'completed',
  canceled: 'canceled',
  refunded: 'refunded',
};
